import {axiosSpringInstance} from "../../../BackofficeApiManager";
import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {Employee} from "../../../../declerations/server/role_models";

type Variables = {
  agentEmail: string | undefined;
};

type Data = Employee;

const getResolutionExpertByEmail = async (variables: Variables): Promise<Data | undefined> => {
  if (!variables.agentEmail) {
    return undefined;
  }
  const response = await axiosSpringInstance.get<Data, AxiosResponse<Data>>(
    `/rex-management/employees/${variables.agentEmail}?expand=roles`
  );
  return response.data;
};

export const useGetResolutionExpertByEmail = (
  variables: Variables,
  options?: BaseQueryOptions<Data | undefined, string>
): BaseUseQueryResult<Data | undefined> => {
  return useBaseQuery<Data | undefined, Variables>(["rex"], getResolutionExpertByEmail, variables, options);
};
